module.exports = __webpack_public_path__ + "static/media/cancel-red.14cabd28.svg";